<!-- 权责清单查询展示页 -->
<template>
    <div class="accrual">
        <c-mask @isRunText="isRunText"></c-mask>
        <div class="accrual-header">
            <v-header ref="vHeader" :isShowSearch="isShowSearch" @buildAccrualListReq="buildAccrualListReq"></v-header>
        </div>
        <div class="accrual-content">
            <div class="v-notice" v-if="isShowNotice" @mouseenter="isShowNoticeBtn = true" @mouseleave="isShowNoticeBtn = false">
                <Icon type="ios-close-circle" class="v-notice-btn" v-if="isShowNoticeBtn" @click="isShowNotice = false"/>
                <Carousel v-model="CarouselValue" loop :autoplay="CarouselSetting.autoplay"
                    :autoplay-speed="CarouselSetting.autoplaySpeed" :dots="CarouselSetting.dots"
                    :radius-dot="CarouselSetting.radiusDot" :trigger="CarouselSetting.trigger"
                    :arrow="CarouselSetting.arrow">
                    <CarouselItem>
                        <span style="color: #f44336; font-size: 14px;">《中华人民共和国个人信息保护法》2021年11月01日开始实施，包含权责事项8项。</span>
                    </CarouselItem>
                    <CarouselItem>
                        <span style="color: #f44336; font-size: 14px;">《中华人民共和国档案法》(2020修订)将于2021年1月1日开始实施，涉及权责事项13项。</span>
                    </CarouselItem>
                    <CarouselItem>
                        <span style="color: #3a97c8; font-size: 14px;">中华人民共和国中外合作经营企业法(2017修正)已经失效，涉及职权事项5项。</span>
                    </CarouselItem>
                </Carousel>
            </div>
            <div class="c-tags">
                <Tag v-for="item in tagListData" :key="item.id" :name="item.name" :closable="isClosable(item)"
                    @on-close="handleClose">
                    {{ item.describe + item.name }}</Tag>
            </div>
            <div class="accrual-nav-container">
                <v-nav ref="vNav" :xscjOption="XscjOption" :zqlyOption="ZqlyParams.zqlyOption" :pageSize="pageSize"
                    @buildAccrualListReq="buildAccrualListReq">
                </v-nav>
            </div>
            <div class="accrual-list-container">
                <div class="accrual-container-title">
                    <span class="zqlx-text">{{ ZqlyParams.zqlyLabel == '' ? '全部部门' : ZqlyParams.zqlyLabel }}</span>
                    <Select style="width:200px" v-model="Zqlx" @on-change="changeZqlx">
                        <Option value="0">全部类型</Option>
                        <Option v-for="item in ZqlxOption" :value="item.lxbm" :key="item.id">{{ item.zqlx }}</Option>
                    </Select>
                </div>
                <div class="accrual-container-content">
                    <c-list :listData="AccrualListData.data" :activeXscj="Xscj"></c-list>
                    <c-page :listData="AccrualListData" @buildAccrualListReq="buildAccrualListReq"></c-page>
                </div>
            </div>
        </div>
        <BackTop :height="backTopHei" :duration="backTopDur" class="btn-backtop">
            <div class="btn-backtop-icon">

            </div>
        </BackTop>
        <div class="accrual-footer">
            <div class="accraul-introduce">
                <a href="javascript:void(0);">北大法宝权责清单智能管理系统简介</a>
            </div>
            <div class="accrual-copyright">
                <div class="copyright-item">
                    <a href="https://pkulaw.com/helps/58.html" target="_blank">英华介绍</a>
                    <span>::</span>
                    <a href="http://www.pkulaw.cn/help/index.html?item=FBKH" target="_blank">经典客户</a>

                    <span>::</span>
                    <a href="https://pkulaw.com/help/more-service-law-notice.html" target="_blank">法律声明</a>
                    <span>::</span>
                    <a href="http://www.pkulaw.cn/css/websit_map.htm" target="_blank">网站地图</a>
                    <span>::</span>

                    <a href="mailto:info@chinalawinfo.com">企业邮箱</a>
                </div>
                <p>版权所有 ：北京北大英华科技有限公司 北京大学法制信息中心 <a href="http://www.beian.miit.gov.cn/"
                        target="_blank">京ICP证010230-17号</a></p>
                <div class="copyright-logo">
                    <a href="http://www.pkulaw.cn/help/ad/20140818/index.html" rel="nofollow" target="_blank">
                        <img src="https://pkulaw.com/content/images/bdfb.jpg" alt="">
                    </a>
                    <a href="https://ss.knet.cn/verifyseal.dll?sn=e13042211010040250ewgy000000&amp;ct=df&amp;a=1&amp;pa=0.3386153630929789"
                        rel="nofollow" target="_blank"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CMask from '@/components/mask/CMask.vue'
    import CList from '@/components/list/CList.vue'
    import CPage from '@/components/page/CPage.vue'
    import VHeader from '@/views/header/VHeader.vue'
    import VNav from '@/views/nav/VNav.vue'
    import { reqAccrualListData } from "@/api/index";
    import { reqDicListData } from "@/api/index";

    export default {
        name: 'Accrual',
        components: {
            CMask,
            CList,
            CPage,
            VHeader,
            VNav
        },
        data() {
            return {
                isShowNotice: true,
                isShowNoticeBtn: false,
                isShowSearch: '1',
                // 行使层级选中值
                Xscj: '',
                // 行使层级字典表
                XscjOption: [],
                // 职权领域参数
                ZqlyParams: {
                    zqly: '',// 职权领域选中值
                    zqlyLabel: '',// 职权领域选择文本值
                    zqlyOption: []// 职权领域字典表
                },
                Zqlx: '0',
                // 职权类型字典表
                ZqlxOption: [],
                // tag显示数据
                tagListData: [],
                // 权责列表数据
                AccrualListData: {},
                // 请求权责列表数据参数
                AccrualListReq: {
                    keyword: '',
                    xscj: '',
                    zqly: '',
                    zqlx: '',
                    pageSize: '',
                    pageNum: ''
                },
                keyword: '',
                pageNum: 1,
                pageSize: 10,
                // 返回顶部临界值
                backTopHei: 10,
                // 返回顶部动画时长
                backTopDur: 600,

                // 轮播图选中页
                CarouselValue: 0,
                // 轮播图参数配置
                CarouselSetting: {
                    autoplay: false,
                    autoplaySpeed: 8000,
                    dots: 'none',
                    radiusDot: true,
                    trigger: 'click',
                    arrow: 'never'
                },
                // isClosable: false
            }
        },
        computed: {

        },
        mounted() {
            let carouselStatus = window.sessionStorage.getItem('carouselStatus');
            // 为null时显示蒙版,禁止文字轮动
            this.CarouselSetting.autoplay = !carouselStatus ? false : true;
            this.getDicListData();
        },
        methods: {
            isClosable(data) {
                let tempBoolean = data.id == 2 ? false : true;
                return tempBoolean;
            },
            handleClose(event, name) {
                // debugger
                this.tagListData.forEach((item, index) => {
                    if (item.name == name) {
                        if (item.id == 1) {
                            this.$refs.vHeader.Keyword = '';
                            this.keyword = '';
                            this.AccrualListReq.keyword = '';
                        }
                        if (item.id == 2) {
                            this.AccrualListReq.xscj = '';
                        }
                        if (item.id == 3) {
                            this.$refs.vNav.active = '全部部门';
                            this.$refs.vNav.ZqlyParams.zqly = '';
                            this.$refs.vNav.ZqlyParams.zqlyLabel = '';
                            this.ZqlyParams.zqly = '';
                            this.ZqlyParams.zqlyLabel = ''
                            this.AccrualListReq.zqly = '';
                        }
                        if (item.id == 4) {
                            this.Zqlx = '0';
                            this.AccrualListReq.zqlx = '';
                        }
                        this.tagListData.splice(index, 1);
                    }
                });
                this.getAccrualListData();
            },

            // 请求，获取字典表数据
            getDicListData() {
                reqDicListData({}).then(res => {
                    if (res.code === 0) {
                        let tempXscj = ['国家级', '省（自治区，直辖市）级', '地级市（州）级', '区县（市）级', '乡镇级', '村居级'];
                        this.XscjOption = res.data.xscj;
                        this.XscjOption.forEach((item, index) => {
                            item.xscj = tempXscj[index];
                        });
                        // this.XscjOption.push({
                        //   cjbm: "00",
                        //   id: "0",
                        //   xscj: "全部"
                        // });
                        this.ZqlyParams.zqlyOption = res.data.zqly;
                        this.ZqlxOption = res.data.zqlx;
                    }
                });
            },

            // 请求参数,拼接权责列表请求参数
            buildAccrualListReq(params, flag, zqlyParams) {
                // console.log(params.pageNum)
                // console.log(params.pageSize)
                this.pageNum = params.pageNum ? params.pageNum : this.pageNum;
                this.pageSize = params.pageSize ? params.pageSize : this.pageSize;
                this.keyword = params.keyword ? params.keyword : this.keyword;
                this.Xscj = params.xscj ? params.xscj : this.Xscj;
                // this.AccrualListReq.keyword = params.keyword ? params.keyword : '';
                // this.AccrualListReq.pageNum = params.pageNum ? params.pageNum : this.pageNum;
                this.AccrualListReq.keyword = this.keyword;
                this.AccrualListReq.pageNum = this.pageNum;
                this.AccrualListReq.pageSize = this.pageSize;
                // this.AccrualListReq.pageSize = params.pageSize ? params.pageSize : this.pageSize;
                this.AccrualListReq.zqlx = this.Zqlx;
                if (zqlyParams) {
                    this.ZqlyParams.zqly = zqlyParams.zqly;
                    this.ZqlyParams.zqlyLabel = zqlyParams.zqlyLabel;
                    // this.ZqlyParams.zqlyOption = zqlyParams.zqlyOption;
                }

                if (flag) {
                    this.tagListData = this.buildParamsLabel(flag, zqlyParams);
                }

                this.AccrualListReq = { ...this.AccrualListReq, ...params };
                this.AccrualListReq.zqlx = this.AccrualListReq.zqlx === '0' ? '' : this.AccrualListReq.zqlx;
                this.AccrualListReq.xscj = this.AccrualListReq.xscj === '00' ? '' : this.AccrualListReq.xscj;
                this.getAccrualListData();
            },


            // 返回参数，获取字典表中对应的汉字拼接成tag需要的数据格式并返回
            buildParamsLabel(flag, zqlyParams) {
                // debugger
                let arr = [];
                // 获取搜索框内容
                if (flag == 'search') {
                    arr.push({
                        id: 1,
                        name: this.AccrualListReq.keyword,
                        describe: '搜索条件：'
                    });
                }
                // 获取行使层级字典表汉字
                if (flag == 'xscj') {
                    this.XscjOption.forEach(item => {
                        if (item.cjbm == this.Xscj) {
                            arr.push({
                                id: 2,
                                name: item.xscj,
                                describe: '行使层级：'
                            });
                            // arr.push(item);
                        }
                    });
                }
                // 获取职权领域字典表汉字
                if (flag == 'zqly') {
                    // 值为全部时，删除本条数据
                    if (zqlyParams.zqly == '') {
                        arr.push({
                            id: 3,
                            name: '全部',
                            describe: ''
                        });
                    } else {
                        if (zqlyParams) {
                            zqlyParams.zqlyOption.forEach(item => {
                                if (zqlyParams.zqly == item.lybm) {
                                    arr.push({
                                        id: 3,
                                        name: item.zqly,
                                        describe: '职权领域：'
                                    });
                                }
                            });
                        }
                    }
                }
                // 获取职权类型字典表汉字
                if (flag == 'zqlx') {
                    // 值为全部时，删除本条数据
                    if (this.Zqlx === '0') {
                        arr.push({
                            id: 4,
                            name: '全部',
                            describe: ''
                        });
                    } else {
                        this.ZqlxOption.forEach(item => {
                            if (this.Zqlx == item.lxbm) {
                                arr.push({
                                    id: 4,
                                    name: item.zqlx,
                                    describe: '职权类型：'
                                });
                            }
                        });
                    }
                }

                // 复写
                this.tagListData.forEach((item, index) => {
                    if (item.id != arr[0].id) {
                        arr.push(item);
                    }
                });

                // 过滤值为全部的数据
                arr.forEach((item, index) => {
                    if (item.name == '全部') {
                        arr.splice(index, 1);
                    }
                });
                // 排序
                arr.sort(this.soryByProperty('id'));
                return arr;
            },

            // 排序
            soryByProperty(property) {
                return (a, b) => {
                    return a[property] - b[property];
                }
            },

            // 请求,获取权责列表数据
            getAccrualListData() {
                // console.log(this.AccrualListReq.pageNum)
                // console.log(this.AccrualListReq.pageSize)
                reqAccrualListData(this.AccrualListReq).then(res => {
                    if (res.code === 0) {
                        this.AccrualListData = res.data;
                    }
                });
            },

            // 请求参数，选择职权类型时替换拼接的参数
            changeZqlx() {
                // iview bug 默认值空会触发两遍，第二遍值为undefined
                if (this.Zqlx || this.Zqlx === '0') {
                    this.buildAccrualListReq({ zqlx: this.Zqlx, pageNum: 1 }, 'zqlx');
                }
            },

            isRunText(data) {
                this.CarouselSetting.autoplay = !data;
            }
        }
    }
</script>

<style scoped>
    .accrual {
        min-height: 100%;
        background-color: #f7f8f8;
    }

    .accrual-header {
        background-color: #fff;
    }

    .accrual-content {
        overflow: hidden;
        padding: 0 20px;
        margin: 0 auto;
        width: 1200px
    }

    .accrual-nav-container {
        margin-bottom: 20px;
        border: 1px solid #e0e8f7;
        border-radius: 3px;
        background-color: #fff;
    }

    .accrual-list-container {
        margin-bottom: 20px;
        border: 1px solid #e0e8f7;
        border-radius: 3px;
        background-color: #fff;
    }

    .accrual-container-title {
        display: flex;
        align-items: center;
        padding: 0 18px;
        border-bottom: 1px solid #e0e8f7;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-weight: bold;
        color: #2d4060;
    }

    .icon-zqlx {
        margin-left: 2px;
        width: 18px;
        height: 18px;
        background: url(../assets/type.png) no-repeat 0 0;
    }

    .zqlx-text {
        margin: 0 32px 0 12px;
    }

    .accrual-container-content {
        padding: 0px 18px 12px 18px;
    }

    .v-notice {
        position: relative;
        margin: 8px 0 0;
        /* padding: 0 20px; */
        /* width: 1500px; */
        font-size: 16px;
        color: #f92841;
    }

    .v-notice-btn {
      position: absolute;
      right: 0;
      top: 4px;
      z-index: 6;
      color: #808695 !important;
      cursor: pointer;
    }

    .c-tags {
        margin: 8px;
    }

    .btn-backtop-icon {
        width: 44px;
        height: 48px;
        background: url(../assets/backtop.png) 0 0 no-repeat;
    }

    .accrual-footer {
        padding: 0 20px;
        color: #fff;
        background-color: #17181e;
    }

    .accraul-introduce {
        padding: 20px;
        text-align: center;
        border-bottom: 1px solid #394c5e;
        /* background-color: #17181e; */
    }

    .accraul-introduce a {
        font-size: 24px;
        color: #fff;
    }

    .accrual-copyright {
        position: relative;
        padding: 20px;
        text-align: center;
        /* background-color: #17181e; */
    }

    .accrual-copyright a {
        color: #fff;
    }

    .copyright-item {
        margin-bottom: 10px;
    }

    .copyright-logo {
        position: absolute;
        top: 24px;
        right: 60px;
    }
</style>